import { Link } from "react-router-dom";
import OptionsInterest from "../../../constant/optionInterest.json";
import { Button, Input, TextArea } from "../../atoms/common";
import { useEffect, useState } from "react";
import SelectBar from "../../atoms/custom/selectBar";
import AOS from 'aos';
import Environtment from '../../../constant/environtment.json';
import {GlobalGet} from "../../../helpers/fetcher";

const AboutPage = (props) => {
  const {REACT_APP_API_URL} = Environtment;
  const [portfolio, setPortfolio] = useState([]);

  const getDataPortfolio = async () => {
    try {
      const respons = await GlobalGet ({url:`${REACT_APP_API_URL}portfolio`});
      setPortfolio(respons?.data?.portofolio);
    } catch (error) {
      console.log(error);
    }
  }

  const {sendFeedback} = props;
  const [dataWorkUs, setDataWorkUs] = useState({
    interest_with: '',
    name: '',
    email: '',
    company: '',
    description: '',
  })

  const onSubmit = (e) =>{
    e.preventDefault();
    sendFeedback(dataWorkUs);
  }

  useEffect(() => {
    AOS.init();
    getDataPortfolio();
  }, []);

  const dataTeam = [
    {
      data1: [
        {
          imgSrc: "https://via.placeholder.com/1000x600.png?text=IMAGE",
          nameTeam:
            "Adi Arriansyah, Managing Partner Alexey McCormack, Venture Partner",
        },
        {
          imgSrc: "https://via.placeholder.com/1000x600.png?text=IMAGE",
          nameTeam: "Richard Tinoko, Venture Partner",
        },
      ],
    },
    {
      data2: [
        {
          imgSrc: "https://via.placeholder.com/1000x600.png?text=IMAGE",
          nameTeam: "Brad Brookes, Venture Partner",
        },
        {
          imgSrc: "https://via.placeholder.com/1000x600.png?text=IMAGE",
          nameTeam: "Alexey McCormack, Venture Partner",
        },
      ],
    },
  ];
  const dataPortofolio = [
    {
      title: "google",
      desc: "Google Partnership — Bringing the best of Google to people across the globe",
    },
    {
      title: "beats by dre",
      desc: "BeatsByDre.com — Leading a digital transformation &amp;eComm redesign",
    },
    {
      title: "crafted",
      desc: "Crafted — Giving creators of all disciplines a seat at the table",
    },
    {
      title: "BB Dakota",
      desc: " BBDakota.com — Bringing storytelling and personality to eCommerce",
    },
  ];
  console.log(portfolio);
  return (
    <div>
      <section className="pt-40 desktop:pb-0 pb-12 bg-[#212121] bg-[url('https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')] bg-p  desktop:bg-[center_top_5rem] bg-contain bg-no-repeat img-blog overflow-hidden relative">
        <div className="max-w-[1200px] flex mx-auto relative  ">
          <div className="flex flex-col desktop:flex-1 desktop:w-full desktop:items-center px-6 mb-12 w-[52.5%]">
            <div className="text-sm font-bold font1  mb-12 text-[#777]">
              <a className=" " href="/">
                <span className="text-blueLink">Home</span>
              </a>
              <span class="fa mx-2 text-[9px]"></span>
              About Us
            </div>
            <div className="px-[40px] py-[64px] bg-white desktop:bg-transparent  ">
              <a
                href="single-post.html"
                className=" text-[#212121] inline-block"
              >
                <h1 className="font2 text-[#333] desktop:text-[#fff] desktop:font-light text-[52px] leading-[1.15] font-semibold mb-2">
                  Our Businesses
                </h1>
                <div className="mb-6 text-xl desktop:text-[#fff] font1 desktop:font-light leading-normal lowercase">
                  SAGARA GROUP IS ONE OF THE WORLD’S LEADING MULTI HIGH-GROWTH
                  ASSETS INVESTMENT FIRMS. OUR GLOBAL TEAM ALIGNS OUR INTERESTS
                  WITH THOSE OF OUR INVESTORS AND PARTNERS FOR LASTING IMPACT.
                </div>
              </a>
            </div>
          </div>
          <div className="flex-col flex-auto w-[47.5%] lg-5 px-12 mb-0" />
        </div>
        <div className="gradient-overlay hidden-only-lg" />
      </section>

      <section className="pt-24 pb-12">
        <div className=" max-w-[1200px] flex desktop:flex-col-reverse items-center  mx-auto relative">
          <div className="desktop:wrap desktop:space-y-4 desktop:w-auto px-6 mb-12 w-7/12 ">
            <iframe
              title="test"
              className="embedly-embed w-full"
              src="https://www.youtube.com/embed/9fAHzPz1kyo"
              width="940"
              height="528"
              scrolling="no"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen="true"
            />
          </div>
          <div className="desktop:flex-col desktop:space-y-4 desktop:w-auto px-6 mb-12 w-1/12" />
          <div className="desktop:flex-col desktop:space-y-4 desktop:w-auto px-6 mb-12 w-4/12">
            <div className="pre-title-container">
              <div className="relative inline-block mb-1 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                what we do
              </div>
              <div className="pre-title-decoration" />
            </div>
            <h3 className="mt-0 mb-[10px] text-[23px] leading-[1.4] font-black font2">
              {" "}
              Investment for tomorrow. Build technology from grassroot.
            </h3>
            <div className="mb-6 font1 text-base leading-6">
              As investors, Sagara Group has a proven track record of acting
              quickly, being flexible and following through on its commitments
              once we identify businesses that have strong fundamentals in our
              targeted space.{" "}
            </div>
            <Link
              to="/services"
              className="align-center font3 text-blueLink text-xs font-bold uppercase "
            >
              <span className="mr-6 hover:underline">explore our capabilities</span>{" "}
              <span className="fa c-cta1_arrow-hovered"></span>{" "}
              <span className="fa c-cta1__arrow-normal"></span>
            </Link>
          </div>
        </div>
      </section>

      <section className="pt-24 pb-12">
        <div className="max-w-[1200px] flex mx-auto">
          <div className="col margin-bottom" />
        </div>
        <div className="max-w-[1200px] mx-auto flex desktop:flex-col">
          <div className="desktop:flex-row desktop:space-y-4 desktop:w-auto px-6 mb-12 w-4/12 mt-24">
            {dataTeam.map((data) => (
              <>
                {data.data1?.map((sub) => (
                  <div className="mb-12">
                    <img src={sub.imgSrc} alt="" className="mb-6" />
                    <div className="font-bold">{sub.nameTeam}</div>
                  </div>
                ))}
              </>
            ))}
          </div>
          <div className="desktop:flex-row desktop:space-y-4 desktop:w-auto px-6 mb-12 w-4/12 relative top-12">
            {dataTeam.map((data) => (
              <>
                {data.data2?.map((sub) => (
                  <div className="mb-12">
                    <img src={sub.imgSrc} alt="" className="mb-6" />
                    <div className="font-bold">{sub.nameTeam}</div>
                  </div>
                ))}
              </>
            ))}
          </div>
          <div className="desktop:flex-wrap desktop:space-y-4 desktop:w-auto px-6 mb-12 w-4/12  md-12 desktop:order-[3] order-[-1] flex flex-col  justify-between">
            <div>
              <div className="pre-title-container">
                <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                  meet our team
                </div>
                <div className="pre-title-decoration" />
              </div>
              <h3 className="mt-0 mb-[10px] text-[23px] leading-snug font-black font2">
                A multi—disciplinary brilliant team of creators
              </h3>
              <div>
                <p className="text-base leading-6 mb-8 text-[#333] font1">
                  Nikisae is a multicultural, multinational and multi-discipline
                  team of individuals who come together to form one team with a
                  focused mission: to create.
                </p>
                <p className="text-base leading-normal mb-8 text-[#333] font1">
                  What we do and why we hustle come from within. With our shared
                  principles in place, we create without fear in an atmosphere
                  that facilitates the greatest work for the greatest clients of
                  earth. Ambition. Talent. Love. Call it what you want. We call
                  it Nikisae.
                </p>
              </div>
            </div>
            <a
              href="/careers"
              className="align-center font3 text-blueLink text-xs font-bold uppercase"
            >
              <span className="mr-6 hover:underline">Join our team</span>{" "}
              {/* <span className="fa c-cta1_arrow-hovered"></span>{" "} */}
              <span className="fa c-cta1__arrow-normal"></span>
            </a>
          </div>
        </div>
      </section>

      <section className="pb-12 relative pt-0">
        <div className="max-w-[1200px] flex mx-auto items-center relative">
          <div className=" mx-auto px-6 mb-12 block ">
            <div className="pre-title-container">
              <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                our portfolio
              </div>
              <div className="pre-title-decoration" />
            </div>
            <h3 className="mt-0 mb-[10px] text-[23px] leading-[1.4] font-black font2">
              Some of the work we're proud of
            </h3>
          </div>
        </div>
        <div className="max-w-[1200px] w-full flex mx-auto relative">
          <div className="px-6 mb-12">
            <div className="grid grid-cols-3 c-grid3x3-2 desktop:grid-cols-1">
              {portfolio?.map((data) => (
                <a href="#" className="card-zoom   ">
                  <div className="c-grid1__content-2 z-[5]">
                    <div className="mb-2 font3 text-xs font-semibold tracking-widest text-[#fff] uppercase">
                      {data.partner_name}
                    </div>
                    <p className="font1 text-[#fff]">
                      {data.short_description.substring(0,100)}...
                      <br />
                    </p>
                  </div>
                  <div className="card-zoom-image" style={{backgroundImage : 'url("${data.image}")'}} />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="background-img img1 align-left push-to-lg-2" />
      </section>

      <section className="w-full flex tablet:flex-col justify-center items-stretch p-10">
        <div className="w-1/2 tablet:w-full p-6 flex items-center">
          <div className="flex flex-col"> 
            <div className="mb-2">
              <span className="text-greenWebsite">OUR FACTS IN NUMBER</span>
            </div>
            <div className="mb-2">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in.</span>
              <Link to={'/'} className="ml-1 text-greenWebsite">
                Read More
              </Link>
            </div>
            <div className="flex flex-wrap">
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">10</span>
                  <span className="text-xl font-thin ml-1">Portfolio Companies</span>
                </div>
                <span className="mt-2 text-base ml-1">
                  We've been operating since 2014
                </span>
              </div>
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">3X</span>
                  <span className="text-xl font-thin ml-1">Value Multiples</span>
                </div>
                <span className="mt-2 text-base ml-1">
                We've helped 990+ clients achieve their goals
                </span>
              </div>
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">6</span>
                  <span className="text-xl font-thin ml-1">Offices</span>
                </div>
                <span className="mt-2 text-base ml-1">
                Our locations are spreaded accross 5 continents
                </span>
              </div>
              <div className="w-1/2 p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">20+</span>
                  <span className="text-xl font-thin ml-1">Professionals</span>
                </div>
                <span className="mt-2 text-base ml-1">
                We've awarded as the best business consulting in 2020
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2 tablet:w-full p-6">
          <form className="bg-white flex flex-col shadow-md p-6 w-full" onSubmit={onSubmit}>
            <span className="text-4xl font-bold">Work With Us</span>
            <span className="text-md my-2 w-full">We will respond to your email within 24 hours</span>
            <SelectBar
              data={OptionsInterest}
              value={dataWorkUs.interest_with}
              handler={(e) => setDataWorkUs({...dataWorkUs, interest_with: e.target.value})}
              defaultChoose={'Pilih Interest...'}
            />
            <Input
              placeHolder="Name"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              type="text"
              required
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.name}
              handler={(e) => setDataWorkUs({...dataWorkUs, name: e})}
            />
            <Input
              placeHolder="Email"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.email}
              type="email"
              required
              handler={(e) => setDataWorkUs({...dataWorkUs, email: e})}
            />
            <Input
              placeHolder="Company"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.company}
              type="text"
              required
              handler={(e) => setDataWorkUs({...dataWorkUs, company: e})}
            />
            <TextArea
              classes={'w-full h-[200px] rounded-m p-1 border-gray-500 border-b'}
              required
              placeHolder={'Project Description'}
              value={dataWorkUs.description}
              handler={(e) => setDataWorkUs({...dataWorkUs, description: e})}
            />
            <Button
              type={'submit'}
              text={'TALK TO OUR TEAM'}
              classes="text-white font-base bg-greenWebsite p-2 rounded-full my-2 w-1/3 tablet:w-1/2"
            />
          </form>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;


// import { Link } from "react-router-dom";
// const AboutPage = () => {
//   return (
//     <div>
//       <section className="section is-header bg-accent-dark has-bg-img position-relative">
//         <div className="gradient-overlay hidden-only-lg" />
//         <div className="container flex-horizontal position-relative">
//           <div className="col lg-8 md-12">
//             <div className="breadcrumb margin-bottom-double">
//               <Link to="/">Home</Link>
//               <span className="fa margin-left-small margin-right-small is-xsmall">
//                 
//               </span>
//               About
//             </div>
//             <div className="header-content-wrapper-2">
//               <h1>Scaling Mission-Driven Companies</h1>
//               <div className="text-medium">
//                 We have a true end-to-end technology platform that lets us
//                 invest from seed stage companies all the way to billion dollar
//                 plus buyouts
//               </div>
//             </div>
//           </div>
//           <div className="col lg-1" />
//           <div className="col lg-6 no-margin-bottom md-12" />
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <div className="col lg-7 md-12">
//             <iframe
//               title="test"
//               className="embedly-embed w-full"
//               src="https://www.youtube.com/embed/9fAHzPz1kyo"
//               width="940"
//               height="528"
//               scrolling="no"
//               frameborder="0"
//               allow="autoplay; fullscreen"
//               allowfullscreen="true"
//             />
//           </div>
//           <div className="col lg-1 no-margin-bottom" />
//           <div className="col lg-4 md-12">
//             <div className="pre-title-container">
//               <div className="pre-title is-left-aligned">what we do</div>
//               <div className="pre-title-decoration" />
//             </div>
//             <h3> Investment for tomorrow. Build technology from grassroot.</h3>
//             <div className="margin-bottom">
//               As investors, Sagara Group has a proven track record of acting
//               quickly, being flexible and following through on its commitments
//               once we identify businesses that have strong fundamentals in our
//               targeted space.{" "}
//             </div>
//             <Link to="#" className="cta-link">
//               <span className="margin-right">explore our capabilities</span>{" "}
//               <span className="fa c-cta1_arrow-hovered"></span>{" "}
//               <span className="fa c-cta1__arrow-normal"></span>
//             </Link>
//           </div>
//         </div>
//       </section>

//       <section className="section">
//         <div className="container">
//           <div className="col margin-bottom" />
//         </div>
//         <div className="container flex-horizontal">
//           <div className="col lg-4 shift-down-quad md-12">
//             <div className="c-team2">
//               <img
//                 src="https://via.placeholder.com/1000x600.png?text=IMAGE"
//                 alt=""
//                 className="margin-bottom"
//               />
//               <div className="is-bold">Adi Arriansyah, Managing Partner</div>
//               <div className="is-bold">Alexey McCormack, Venture Partner</div>
//             </div>
//             <div className="c-team2">
//               <img
//                 src="https://via.placeholder.com/1000x600.png?text=IMAGE"
//                 alt=""
//                 className="margin-bottom"
//               />
//               <div className="is-bold">Richard Tinoko, Venture Partner</div>
//             </div>
//           </div>
//           <div className="col lg-4 shift-down-double md-12">
//             <div className="c-team2">
//               <img
//                 src="https://via.placeholder.com/1000x600.png?text=IMAGE"
//                 alt=""
//                 className="margin-bottom"
//               />
//               <div className="is-bold">Brad Brookes, Venture Partner</div>
//             </div>
//             <div className="c-team2">
//               <img
//                 src="https://via.placeholder.com/1000x600.png?text=IMAGE"
//                 alt=""
//                 className="margin-bottom"
//               />
//               <div className="is-bold">Alexey McCormack, Venture Partner</div>
//             </div>
//           </div>
//           <div className="col lg-4 flexv-space-between md-12 order-first">
//             <div>
//               <div className="pre-title-container">
//                 <div className="pre-title is-left-aligned">meet our team</div>
//                 <div className="pre-title-decoration" />
//               </div>
//               <h3 className="margin-bottom">
//                 A multi—disciplinary brilliant team of creators
//               </h3>
//               <div className="margin-bottom w-richtext">
//                 <p>
//                   Nikisae is a multicultural, multinational and multi-discipline
//                   team of individuals who come together to form one team with a
//                   focused mission: to create.
//                 </p>
//                 <p>
//                   What we do and why we hustle come from within. With our shared
//                   principles in place, we create without fear in an atmosphere
//                   that facilitates the greatest work for the greatest clients of
//                   earth. Ambition. Talent. Love. Call it what you want. We call
//                   it Nikisae.
//                 </p>
//               </div>
//             </div>
//             <a href="#" className="cta-link">
//               <span className="margin-right">Join out team</span>{" "}
//               <span className="fa c-cta1_arrow-hovered"></span>{" "}
//               <span className="fa c-cta1__arrow-normal"></span>
//             </a>
//           </div>
//         </div>
//       </section>

//       <section className="section position-relative no-padding-top">
//         <div className="container position-relative">
//           <div className="col lg-7 block-centered">
//             <div className="pre-title-container">
//               <div className="pre-title is-left-aligned">our portfolio</div>
//               <div className="pre-title-decoration" />
//             </div>
//             <h3>Some of the work we're proud of</h3>
//           </div>
//         </div>
//         <div className="container position-relative">
//           <div className="col lg-12">
//             <div className="w-layout-grid c-grid3x3-2">
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b7f0"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">Google</div>
//                   <p className="paragraph">
//                     Google Partnership — Bringing the best of Google to people
//                     across the globe
//                     <br />
//                   </p>
//                 </div>
//                 <div
//                   style={{
//                     WebkitTransform:
//                       "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//                     MozTransform:
//                       "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//                     msTransform:
//                       "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//                     transform:
//                       "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
//                   }}
//                   className="c-grid1__image"
//                 />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b7f8"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">beats by dre</div>
//                   <p className="paragraph">
//                     BeatsByDre.com — Leading a digital transformation &amp;
//                     eComm redesign
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img2" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b800"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">crafted</div>
//                   <p className="paragraph">
//                     Crafted — Giving creators of all disciplines a seat at the
//                     table
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img3" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b808"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">BB Dakota</div>
//                   <p className="paragraph">
//                     BBDakota.com — Bringing storytelling and personality to
//                     eCommerce
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img4" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b810"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">djavaweb</div>
//                   <p className="paragraph">
//                     Culture Manual — Realigning company culture through brand
//                     &amp; digital
//                     <br />
//                     Explore Case Study
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img5" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b81a"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">softbank vision fund</div>
//                   <p className="paragraph">
//                     VisionFund.com — Digitally enriching a multibillion-dollar
//                     enterprise
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img6" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b822"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">heath ceramic</div>
//                   <p className="paragraph">
//                     HeathCeramics.com - An eCommerce experience as crafted as
//                     their products
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img7" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b82a"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">OXO</div>
//                   <p className="paragraph">
//                     OXO.com — Bridging the gap between kitchen and keyboard
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img8" />
//               </a>
//               <a
//                 data-w-id="5f883527-e068-eeaf-1a95-d8c209c3b832"
//                 href="#"
//                 className="c-grid1__item-3 w-inline-block"
//               >
//                 <div className="c-grid1__content-2 zindex5">
//                   <div className="c-grid1__partner">Nixon</div>
//                   <p className="paragraph">
//                     Nixon.com — An eComm &amp; digital transformation driving
//                     global growth
//                     <br />
//                   </p>
//                 </div>
//                 <div className="c-grid1__image img9" />
//               </a>
//             </div>
//           </div>
//         </div>
//         <div className="background-img img1 align-left push-to-lg-2" />
//       </section>
//     </div>
//   );
// };

// export default AboutPage;
